import type { ZInfer, donationCampaignSchema } from 'types';
import { Api } from '../fetch';

export class DonationCampaignNet {
  static get = (visibleOnly: boolean = true) =>
    Api.get<'donationCampaign', 'get'>(`/donation/campaigns`, { query: { visibleOnly } });
  static upsert = (body: ZInfer<typeof donationCampaignSchema>) =>
    Api.post<'donationCampaign', 'upsert'>(`/donation/campaign`, { body });
}
